import { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import clsx from 'clsx';
import _find from 'lodash/find';
import _get from 'lodash/get';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 195,
    margin: theme.spacing(1, 0, 2, 0),
    display: 'block',
  },
}));

const SelectField = (props) => {
  const {
    name,
    label,
    disabled,
    touched,
    options,
    hidden,
    className,
    helperText,
    labelWidth: initialLabelWidth,
    startAdornment,
    placeholder,
  } = props;
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(initialLabelWidth);

  useEffect(() => {
    if (!hidden) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, [hidden]);

  const classes = useStyles();
  return (
    <Field name={name}>
      {({ field, form }) => (
        <FormControl
          error={(touched || form.touched[field.name]) && Boolean(form.errors[field.name])}
          disabled={disabled}
          variant="outlined"
          className={clsx(classes.formControl, className)}
        >
          <InputLabel ref={inputLabel} htmlFor={name} shrink={true}>
            {label}
          </InputLabel>
          <Select
            onChange={field.onChange}
            onBlur={field.onBlur}
            value={field.value || ''}
            displayEmpty={Boolean(placeholder)}
            renderValue={(value) => {
              if (!value && placeholder) {
                return placeholder;
              }
              return _get(_find(options, ({ value }) => value === field.value), 'label');
            }}
            input={
              <OutlinedInput
                labelWidth={labelWidth}
                name={field.name}
                id={field.name}
                startAdornment={startAdornment}
              />
            }
          >
            {placeholder && (
              <MenuItem value={null} key="placeholder">{placeholder}</MenuItem>
            )}
            {options.map((option) => (
              <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
            ))}
          </Select>
          {(((touched || form.touched[field.name]) && form.errors[field.name]) || helperText) && (
            <FormHelperText>
              {((touched || form.touched[field.name]) && form.errors[field.name]) || helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    </Field>
  );
};

SelectField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  options: PropTypes.array,
  hidden: PropTypes.bool,
  className: PropTypes.string,
  helperText: PropTypes.node,
  loading: PropTypes.bool,
  labelWidth: PropTypes.number,
  startAdornment: PropTypes.node,
  placeholder: PropTypes.string,
};

SelectField.defaultProps = {
  labelWidth: 0,
};

export default SelectField;
